import { unref as _unref, isRef as _isRef, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["id", "name", "value"];
const _hoisted_2 = ["for"];
import { toRefs } from 'vue';
export default {
  __name: 'AppgRadio',
  props: {
    id: {
      type: String,
      default: () => Math.random() + ''
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: [Boolean, String, Number],
      default: true
    },
    modelValue: {
      type: [Boolean, String, Number],
      default: true
    },
    label: {
      type: String,
      default: ''
    },
    _class: {
      type: String,
      default: ''
    }
  },
  emits: '',
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const props = __props;
    const {
      id,
      name,
      value,
      modelValue
    } = toRefs(props);
    const input = $event => {
      emit('update:modelValue', $event.target.value);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([__props._class, "form-check"])
      }, [_withDirectives(_createElementVNode("input", {
        id: _unref(id),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(modelValue) ? modelValue.value = $event : null),
        name: _unref(name),
        value: _unref(value),
        class: "form-check-input",
        type: "radio",
        onInput: input
      }, null, 40, _hoisted_1), [[_vModelRadio, _unref(modelValue)]]), _createElementVNode("label", {
        for: _unref(id),
        class: "custom-control-label"
      }, [_renderSlot(_ctx.$slots, "default"), _createTextVNode(" " + _toDisplayString(__props.label), 1)], 8, _hoisted_2)], 2);
    };
  }
};